<template>
    <div class="login">
      <div class="login-main">
        <div style="cursor: pointer;" class="login-logo">
          <img @click="pageCut('/home')" src="@/assets/login/new-login-logo.png" alt="">
        </div>

        <div class="login-content">
          <h1>统一登录中心</h1>
          <el-tabs class="ID-btn" v-model="activeName" type="card" >
            <el-tab-pane class="form-content"
              v-for="(item,index) in userID"
              :key="index"
              :name="item.activeName">
                <!-- 用户身份插槽 -->
                <span slot="label">
                  <i v-if="item.name === '普通用户' " class="el-icon-s-custom"></i>
                  <i v-if="item.name === '园区用户' " class="el-icon-office-building"></i>
                  {{item.name}}
                </span>

                <el-form class="demo-dynamic"
                  label-width="80px"
                  label-position='left'
                  ref="form"
                  :rules="rules"
                  :model="form">
                  <el-form-item label="手机号："  v-if="item.name === '普通用户' " prop="userPhone">
                    <el-input v-model="form.userPhone" placeholder="请输入手机号"></el-input>
                  </el-form-item>

                  <el-form-item label="账号：" v-if="item.name === '园区用户' " prop="accountNum">
                    <el-input v-model="form.accountNum" placeholder="请输入账号"></el-input>
                  </el-form-item>

                  <el-form-item label="密 码：" prop="commonPassword" v-if="item.name === '普通用户' ">
                    <el-input v-model="form.commonPassword" auto-complete="new-password" type="password" placeholder="请输入密码"></el-input>
                  </el-form-item>

                  <el-form-item label="密 码：" prop="gardenPassword" v-if="item.name === '园区用户' ">
                    <el-input v-model="form.gardenPassword" auto-complete="new-password" type="password" placeholder="请输入密码"></el-input>
                  </el-form-item>

                  <el-form-item label="识别码：" prop="headingCode">
                    <el-input v-model="form.headingCode" placeholder="请输入识别码"></el-input>
                    <div class="heading-code-box" @click="getHeadingCode">
                      <img :src="headingCodeImg" alt="">
                    </div>
                    <span class="change-codeImg" @click="getHeadingCode">看不清？换一张</span>
                  </el-form-item>

                  <div class="logIn-btn" v-if="item.name === '普通用户' " @click="commonDoLogin('common')">登 录</div>
                  <div class="logIn-btn" v-if="item.name === '园区用户' " @click="gardenDoLogin('garden')">登 录</div>
                </el-form>

                <el-checkbox class="form-styles" v-model="selfMotion">30天内自动登录</el-checkbox>

                <p class="skip-link" v-if="item.name === '普通用户' ">
                  <span class="forgive-password" @click="pageCut('/forgetPassword')" > 忘记密码> </span>
                  <span @click="pageCut('/register')" style="cursor: pointer;"> 立即注册> </span>
                </p>

                <p class="skip-link" v-if="item.name === '园区用户' ">忘记密码请联系联盟</p>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'login',
  props: {

  },
  components: {

  },
  data () {
    return {
      activeName: 'first',
      dynamicValidateForm: '',
      userID: [
        {
          name: '普通用户',
          activeName: 'first'
        },
        {
          name: '园区用户',
          activeName: 'second'
        }
      ],
      form: {
        userPhone: '', // 普通用户手机号
        accountNum: '', // 园区用户账号
        commonPassword: '', // 密码
        gardenPassword: '', // 密码
        headingCode: '' // 识别码
      },
      rules: {
        userPhone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        accountNum: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        commonPassword: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { pattern: /^[0-9A-Za-z]{6,12}$/, message: '密码格式为6-12位数字或字母或两者组合，区分大小写', trigger: 'blur' }
        ],
        gardenPassword: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { pattern: /^[0-9A-Za-z]{4,16}$/, message: '密码格式为4-16位数字或字母或两者组合，区分大小写', trigger: 'blur' }
        ],
        headingCode: [
          { required: true, message: '请输入识别码', trigger: 'blur' }
        ]
      },
      headingCodeImg: '', // 识别码图片
      uuid: '', // 用户身份识别id
      selfMotion: false, // 自动登录
      userType: '' // 用户类型
    }
  },
  computed: {

  },
  created () {
    this.getHeadingCode()
  },
  mounted () {

  },
  methods: {
    // 登录注册页面切换
    pageCut (path) {
      this.$router.push(path)
    },

    // 获取识别码
    async getHeadingCode () {
      try {
        const res = await this.$get(this.$url.login.getHeadingCode)
        const { code, msg, data } = res.data
        if (code === 200) {
          this.uuid = data.uuid
          this.headingCodeImg = data.img
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },

    // 普通用户登录
    async commonDoLogin (type) {
      try {
        if (this.form.userPhone === '') { this.$message.error('请填写手机号！'); return false }
        if (this.form.password === '') { this.$message.error('请填写密码！'); return false }
        const res = await this.$post(this.$url.login.commonLogin, {
          code: this.form.headingCode,
          passWord: this.form.commonPassword,
          phoneCode: '',
          userName: this.form.userPhone,
          uuid: this.uuid
        })
        const { code, msg, data } = res.data
        if (code === 200 && data) {
          if (this.selfMotion) {
            localStorage.setItem('tokenStr', data.token)
            localStorage.setItem('userType', type)
            this.$router.push('/home')
          } else {
            sessionStorage.setItem('tokenStr', data.token)
            sessionStorage.setItem('userType', type)
            this.$router.push('/home')
          }
        } else {
          this.$message.error(msg)
          this.getHeadingCode()
        }
      } catch (err) {
        console.log(err)
      }
    },

    // 园区用户登录
    gardenDoLogin (type) {
      if (this.form.accountNum === '') { this.$message.error('请填写账号！'); return false }
      if (this.form.password === '') { this.$message.error('请填写密码！'); return false }
      if (this.form.headingCode === '') { this.$message.error('请填写识别码！'); return false }

      this.$post(this.$url.login.gardenLogin, {
        code: this.form.headingCode,
        passWord: this.form.gardenPassword,
        phoneCode: '',
        userName: this.form.accountNum,
        uuid: this.uuid
      }).then(res => {
        console.log(res)
        const { code, msg, data } = res.data
        if (code === 200 && data) {
          if (this.selfMotion) {
            localStorage.setItem('tokenStr', data.token)
            localStorage.setItem('userType', type)
            this.$router.push('/home')
          } else {
            sessionStorage.setItem('tokenStr', data.token)
            sessionStorage.setItem('userType', type)
            this.$router.push('/home')
          }
        } else {
          this.$message.error(msg)
        }
        this.getHeadingCode()
      })
    }
  }
}
</script>

<style scoped lang="less">
.login{
  display: flex;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background:url('~@/assets/login/login-bg.jpg') no-repeat ;
  background-size: cover;
}
.login-main{
  display: flex;
  width: 1200px;
  height: 628px;
  background-color: #fff;
  border-radius: 8px;
  margin: 0 auto;
}
.login-logo{
  width: 484px;
  height: 628px;
}
.login-content{
  position: relative;
  width: 100%;
  height: 628px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  border-radius: 0 8px 8px 0;
  h1{
    font-size: 30px;
    font-weight: 600;
  }
  .ID-btn{
    margin-top: 31px;
    .form-content{
      margin-top: 21px;
      .logIn-btn{
        width: 370px;
        height: 48px;
        line-height: 48px;
        border: 1px solid #3056D9;
        background-color: #3056D9;
        text-align: center;
        color: #fff;
        margin-top: 28px;
      }

      .form-styles{
        margin: 14px 0 44px;
      }
      .skip-link{
        position: absolute;
        bottom: 25px;
        right: 30px;
        font-size: 14px;
        text-decoration: underline;
        .forgive-password{
          margin-right: 12px;
        }
      }
    }
  }
  .demo-dynamic{
    position: relative;
    .change-codeImg{
      position: absolute;
      top: -5px;
      right: 90px;
      z-index: 10;
      font-size: 12px;
      color: #3056D9;
      cursor: pointer;
    }
    .heading-code-box{
      position: absolute;
      top: -5px;
      right: 180px;
      z-index: 10;
      width: 114px;
      height: 36px;
      border: 1px solid #ccc;
      border-radius: 2px;
      img{
        width: 114px;
        height: 36px;
      }
    }
  }
}

/deep/.is-top{
  height: 44px;
  border-radius: 22px;
  border: 0px !important;
}
/deep/.el-tabs__header{
  box-sizing: border-box;
  padding-left: 180px;
}
/deep/.el-tabs__content{
  width: 716px;
  height: 100%;
  box-sizing: border-box;
  padding-left: 180px;
}
/deep/.el-tabs__item{
  width: 180px;
  height: 44px;
  line-height: 44px;
  text-align: center;
  border-radius: 22px;
  font-size: 20px;
  border: 1px solid #E1E1E1;
}
/deep/.is-active{
  background-color: #3056D9;
  color: #fff;
}
/deep/#tab-first{
  margin-right: 12px;
}
/deep/#tab-first,
/deep/#tab-second{
  border: 1px solid #E1E1E1 !important;
}

/deep/.el-form-item__label{
  border-bottom: 1px solid #BCBFC6;
  font-size: 14px;
  color: #000;
}
/deep/.el-input__inner{
  width: 290px;
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid #BCBFC6;
  margin-top: 1px;
  padding: 0;
  font-size: 14px;
  color: #000;
}

.noMargin{
  margin-right: 0 !important;
}
.checkUserStyle{
   background-color: #3056D9;
   color: #fff;
}
</style>
